import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    // padding: theme.spacing(2),
  },
  submitSection: {
    flip: false,
    zIndex: 5,
    position: 'sticky',
    bottom: 0,
    padding: theme.spacing(1, 0),
    // boxShadow: '0px -1px 1px 0px rgba(0, 0, 0, 0.1)',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
  },
  submitButton: {
    flip: false,
    marginLeft: theme.spacing(2),
  },
}))
